var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kk-zuruck",class:{
    'kk-zuruck--hidden': !_vm.visible,
    'kk-zuruck--with-aux-bar': _vm.withAuxBar,
  }},[_c('kk-arrow',{attrs:{"rotate":270},on:{"click":_vm.onZuruck}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }